import styles from '../styles.scss';
import { IconPlus } from 'components/Shared/Icon';
import cn from 'classnames';
import { rm, hasElements } from 'utils';
import { TreeNavigation } from 'models/TreeNavigation';
import { useToggle } from 'hooks';
import { useNavigation } from '../navigation';
import { Level } from '../level';
import { Item } from '../item';
import { Header } from '../header';

export const TreeNavigationBlock = (props: TreeNavigation) => {
  const { items, title } = props;
  const [isToggled, toggle] = useToggle(false);
  const hasChildren = hasElements(items);
  const isOpen = isToggled && hasChildren;
  const { navigationMap } = useNavigation();
  return (
    <Item>
      <Header onMouseDown={toggle}>
        {hasChildren && <IconPlus size="small" className={cn({ [styles.isOpen]: isOpen })} />}
        {title}
      </Header>
      {isOpen && (
        <Level>
          {props.url && (
            <Header>
              <a href={props.url}>{rm('navigation_goto_title', title)}</a>
            </Header>
          )}
          {items.map(navigationMap)}
        </Level>
      )}
    </Item>
  );
};
